<div class="chat-header" [ngClass]="{'blur-content': limitPopupService.limitReached$ | async}">
  <a class="back" routerLink="/" queryParamsHandling="preserve"
     aria-label="Retour"
     i18n-aria-label="Component 'chat', header back button label@@chat_component.header.back">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </a>
  <div class="avatar"></div>
  <div class="identity">
    <span class="name" i18n="Component 'chat', header, title (bot name)@@chat_component.header.title">Isabella</span>
    <span class="status">
      <span class="dot"></span>
      <ng-container i18n="Component 'chat', header availability@@chat_component.header.status">Disponible maintenant</ng-container>
    </span>
  </div>
</div>

<div class="chat-bot" [ngClass]="{'blur-content': limitPopupService.limitReached$ | async}">
  <div class="chat" #container>
    @for(message of messages$ | async; track message.timestamp) {
      @if(message.type === 'text' && ((message.content && message.content.length > 0) || message.special_action === 'start_drawing' || message.experts) ) {
        @if ((message.content && message.content.length > 0) || message.special_action === 'start_drawing') {
          <div #messages class="message" [ngClass]="message.role === 'ai' ? 'bot' : 'me'">
            <div class="bubble-col">
              <div class="bubble">
                <div>{{message.content}}</div>
                @if (message.special_action === 'start_drawing') {
                  <app-tdj
                    (drawingEvent)="sendCards($event)"
                  [cards]="externalCards"></app-tdj>
                }
              </div>
              <div class="meta">
                <span class="time">{{ formatTime(message.timestamp) }}</span>
                @if (message.role !== 'ai') {
                  @if (message.tempId) {
                    <svg class="tick" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Envoyé"
                         i18n-aria-label="Component 'chat', message sent status@@chat_component.message.sent">
                      <path d="M4 12.5l5 5L20 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  } @else {
                    <svg class="tick read" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Lu"
                         i18n-aria-label="Component 'chat', message read status@@chat_component.message.read">
                      <path d="M2 12.5l5 5L16 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 17.5L19 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                }
              </div>
            </div>
          </div>
        }
        @if (message.experts) {
          <app-end-chat #messages [experts]="message.experts"></app-end-chat>
        }
      }
    }
      @if (typing$ | async) {
        <div class="message bot">
          <div class="bubble">
            <div class="dot-flashing"></div>
          </div>
        </div>
      }
    </div>

    <form class="actions" [formGroup]="form" (ngSubmit)="sendMessage($event)" [ngClass]="{disabled: form.disabled}">
      @if((discussionClosed$ | async) === false) {
        <label class="textarea-container">
          <textarea cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"
            formControlName="message"
            (keydown.enter)="sendMessage($event)"
            aria-label="Message"
            i18n-aria-label="Component 'chat', textarea field label@@chat_component.textarea.label"
            placeholder="Écrivez ce que vous ressentez..."
          i18n-placeholder="Component 'chat', textarea field placeholder@@chat_component.textarea.placeholder"></textarea>
        </label>
        <button type="submit" class="send"
          aria-label="Envoyer"
          i18n-aria-label="Component 'chat', submit button label@@chat_component.submit_button.label">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 12l16-8-6 16-3-7-7-1z" fill="currentColor"/>
          </svg>
        </button>
      } @else {
        <!--      <button type="button" style="display: none" (click)="reset()">RESET</button>-->
      }
      @if ((debug$ | async) === true) {
        <button type="button" (click)="reset()">RESET</button>
      }
    </form>

    <div class="secure-note">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="10" width="16" height="11" rx="2.5" stroke="currentColor" stroke-width="1.8"/>
        <path d="M8 10V7a4 4 0 1 1 8 0v3" stroke="currentColor" stroke-width="1.8"/>
      </svg>
      <span i18n="Component 'chat', secure footer note@@chat_component.secure_note">Vos échanges sont sécurisés et confidentiels</span>
    </div>
  </div>

<!-- Popup de limite atteinte -->
<app-limit-popup></app-limit-popup>
